import React from 'react'
import Play from '../../../assets/codicons/play.svg'
import Profile from '../../../assets/codicons/profile.svg'
import { difficultyIconMap } from 'components_v1/ClassView/DifficultyIntensity'
import CommonLink from 'components_v2/CommonLink'

const DifficultyIcon = ({ level }) => {
  const IconComponent = difficultyIconMap[level.toLowerCase()]

  if (!IconComponent) return null

  return <IconComponent className='codicon' />
}

const numberWithDelimiter = (num) => (num != null ? num.toLocaleString() : '0')

const counterNumber = (count, { threshold = 1000, precision = 2 } = {}) => {
  if (count == null) return '0'
  if (count >= threshold) {
    const units = [
      { value: 1_000_000, suffix: 'm' },
      { value: 1_000, suffix: 'k' }
    ]
    for (const { value, suffix } of units) {
      if (count >= value) {
        return (count / value).toFixed(precision).replace(/\.?0+$/, '') + suffix
      }
    }
  }
  return numberWithDelimiter(count)
}

const getAltText = (product) =>
  `${product.formattedCoachNames}'s "${product.title}" Online Video Workouts on ALO Wellness Club`

// --- Sub-components ---

const CoverImage = ({ product, destinationLink, owl, lazyload }) => {
  if (!product.coverPhotoUrl) return null

  const alt = getAltText(product)

  if (owl) {
    return (
      <>
        <CommonLink to={destinationLink} data-refmarks-element='true'>
          <img
            data-src={product.coverPhotoUrl}
            className='plan-cover product-cover owl-lazy'
            alt={alt}
            data-pin-no-hover='true'
          />
        </CommonLink>
        <img
          src='https://d28gwrkukqy4h7.cloudfront.net/16-9-transparent.gif'
          className='placeholder'
          data-pin-no-hover='true'
          alt=''
        />
      </>
    )
  }

  return (
    <CommonLink to={destinationLink} data-refmarks-element='true'>
      <img
        src={product.coverPhotoUrl}
        {...(lazyload
          ? { 'data-src': product.coverPhotoUrl, loading: 'lazy' }
          : {})}
        className='plan-cover product-cover'
        alt={alt}
      />
    </CommonLink>
  )
}

const ProductBadges = ({ product, destinationLink, showBundleBadge }) => {
  const primaryCategory = product.primaryCategory

  return (
    <div className='product-badges'>
      <div category-label-formatter=''>
        {primaryCategory && (
          <div className='product-category'>
            <CommonLink to={destinationLink} data-refmarks-element='true'>
              <span className='category-label'>{primaryCategory.title}</span>
            </CommonLink>
          </div>
        )}
      </div>
      {product.bundle && showBundleBadge && (
        <div className='product-bundle-tag'>Bundle</div>
      )}
    </div>
  )
}

const ProductStats = ({ product }) => (
  <>
    <div className='product-details-push' />
    <div className='product-details hover-content'>
      <div className='product-price-container'>
        <div className='product-videos'>
          <Play className='codicon' />
          {numberWithDelimiter(product.workoutCount)}
        </div>
      </div>

      <div className='product-type'>
        {product.difficultyLevel && (
          <div className='product-difficulty'>
            <DifficultyIcon level={product.difficultyLevel.toLowerCase()} />
            <span className='level level-small'>
              {product.difficultyLevel
                .slice(0, 3)
                .replace(/^./, (c) => c.toUpperCase())}
            </span>
            <span className='level level-lg'>
              {product.difficultyLevel.charAt(0).toUpperCase() +
                product.difficultyLevel.slice(1).toLowerCase()}
            </span>
          </div>
        )}
      </div>

      <div className='product-members'>
        <Profile className='codicon' />
        <span className='compact'>
          {counterNumber(product.membersCount, {
            threshold: 1000,
            precision: 2
          })}
        </span>
        <span className='full'>
          {numberWithDelimiter(product.membersCount)}
        </span>
      </div>
    </div>
  </>
)

const ProductCell = ({
  product,
  hideStatsAndPrice = false,
  lazyload = true,
  showBundleBadge = false,
  hoverable = false,
  owl = false
}) => {
  const destinationLink = `/series/${product.slug}`

  return (
    <div
      className='product-tile'
      {...(hoverable ? { 'hoverable-card': '' } : {})}
      data-refmarks-block='true'
    >
      {/* Cover */}
      <div className='product-cover-container'>
        <CoverImage
          product={product}
          destinationLink={destinationLink}
          owl={owl}
          lazyload={lazyload}
        />
      </div>

      {/* Badges */}
      <ProductBadges
        product={product}
        destinationLink={destinationLink}
        showBundleBadge={showBundleBadge}
      />

      {/* Meta */}
      <div className={`product-info-container hover-content save-content`}>
        <div className='product-meta'>
          <h4 className='product-title'>
            <CommonLink to={destinationLink} data-refmarks-element='true'>
              {product.title}
            </CommonLink>
          </h4>
          <div className='product-coach'>
            {/* <CoachesLink coaches={product.coaches} /> */}
          </div>
        </div>
      </div>

      {/* Stats */}
      {!hideStatsAndPrice && <ProductStats product={product} />}
    </div>
  )
}

export default ProductCell
